/* bundle product js */

$(document).ready(function(){
  $(document).on( "click", ".add-to-bundle-btn", function() {
    var sel_pro_title = $(this).parent("article").find(".product-item-title").text();
    var sel_step = $(this).parents(".acc__panel").attr("data-step");
    var sel_step_limit = $(this).parents(".acc__panel").attr("data-step-limit");
    var sel_pro_img = $(this).parent("article").attr("data-product-img");
    var sel_coll = $(this).parents(".acc__panel").attr("data-collection"); 
    var img_html = '<img src="'+sel_pro_img+'" class="sel_proimg">'; 
     
    if(sel_step_limit > 1){
      var allval = $(this).parents('.tab-content').find('.featured_product_wrapper .action_wrapper input[data-property="'+sel_step+'"]').val();
      var empty_div =$(this).parents('.tab-content').find(".featured_product_wrapper .bundle_product."+sel_step+":empty").length;
      
     
        if(empty_div == 0) {
          var $current_sel = $(this);
         $(this).parents(".acc__panel").find("article.selected_product").each(function(i) {
             if(i == 0){
              $(this).removeClass("selected_product");
              $(this).find(".add-to-bundle-btn").text("Add to Bundle");
               $current_sel.parent("article").addClass("selected_product");
               $current_sel.html("Added <span>&#128525;</span>");
             }
         });
        }else{
          $(this).parent("article").addClass("selected_product");
          $(this).html("Added <span>&#128525;</span>");
        }

      $(this).parents('.tab-content').find(".featured_product_wrapper .bundle_product."+sel_step).each(function(i) {
        if($(this).is(':empty')){
          $(this).html(img_html);
          if(allval == ''){
            $(this).parents('.tab-content').find('.featured_product_wrapper .action_wrapper input[data-property="'+sel_step+'"]').val(sel_pro_title);
          }else{
            $(this).parents('.tab-content').find('.featured_product_wrapper .action_wrapper input[data-property="'+sel_step+'"]').val(allval + ", " + sel_pro_title);
          }
          return false;
        }else if(empty_div == 0) {
          if(i == 0){
            $(this).html(img_html);
            var temp = new Array();
            temp = allval.split(", ");
            temp[0] = sel_pro_title;
            $(this).parents('.tab-content').find('.featured_product_wrapper .action_wrapper input[data-property="'+sel_step+'"]').val(temp.join(", "));
            return false;
          }
        }
      });
    }else{
      $(this).parents(".acc__panel").find("article").removeClass("selected_product");
      $(this).parent("article").addClass("selected_product");
      $(this).parents(".acc__panel").find(".add-to-bundle-btn").text("Add to Bundle");
      $(this).html("Added <span>&#128525;</span>");
      
      $(this).parents('.tab-content').find(".featured_product_wrapper .bundle_product."+sel_step).html(img_html);
      $(this).parents('.tab-content').find('.featured_product_wrapper .action_wrapper input[data-property="'+sel_step+'"]').val(sel_pro_title);
    }
    var empty_bundle_pro = 0;
     $(this).parents('.tab-content').find(".featured_product_wrapper .bundle_product").each(function(i) {
        if($(this).is(':empty')){
          empty_bundle_pro = empty_bundle_pro + 1;
        }
     });
    //console.log("empty_bundle_pro : " + empty_bundle_pro);
    if(empty_bundle_pro == 0){
      $(this).parents('.tab-content').find('.featured_product_wrapper .action_wrapper').find('button').removeAttr('disabled');
    }
  });

});

$(document).on('click','.acc__panel .product-item button',function(e){ 
  e.preventDefault();
 
  var varID = $(this).parent('form').find('input[name="id"]').val(); 
  $(this).html("Added <span>&#128525;</span>");

  $.ajax({
  type: 'POST',
  url: '/cart/add.js',
  data: {
    quantity: 1,
    id: varID
  },
    dataType: 'json', 
   success: function (data) { 
    //$('#CartCount span:first').text(data.quantity);
    //console.log(data.quantity);
   } 
   });

});



